module.exports = __webpack_public_path__ + "7bddede9a631785971b762c6d30724be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Avenir-Light.svg?v=8.0d5e4
// module id = 932
// module chunks = 24